<template>
    <div v-bind:style=" !aboutPage ? 'margin-top: -100px;' : '' ">
        <div class="container" v-if="aboutPage">
            <div class="progress-bar">
                <div class="bar" :style="`width: ${percentage}%;`"></div>
            </div>
            <nav class="page-navigation">
                <ul>
                    <li><a :class="{ active: activeSection === 'the-company' }" href="#the-company"><span>{{ title('the-company') }}</span></a></li>
                    <li><a :class="{ active: activeSection === 'our-vision' }" href="#our-vision"><span>{{ title('our-vision') }}</span></a></li>
                    <li><a :class="{ active: activeSection === 'value-system' }" href="#value-system"><span>{{ title('value-system') }}</span></a></li>
                    <li v-if="w > 868"><a :class="{ active: activeSection === 'history' }" href="#history"><span>{{ title('history') }}</span></a></li>
                    <li v-if="w <= 868"><a :class="{ active: activeSection === 'history-mobile' }" href="#history-mobile"><span>{{ title('history') }}</span></a></li>
                    <li v-if="!aboutPage"><a :class="{ active: activeSection === 'management' }" href="#management"><span>{{ title('management') }}</span></a></li>
                </ul>
            </nav>
            <about-intro class="section" ref="the-company"></about-intro>
        </div>
        <vision-mission class="section" ref="our-vision" v-if="aboutPage"></vision-mission>
        <div class="container" v-if="aboutPage">
            <ertek-rend class="section" ref="value-system"></ertek-rend>
        </div>
        <history class="section" ref="history" v-if="aboutPage"></history>
        <section class="section" id="management" ref="management" v-if="!aboutPage">
            <div class="container">
                <h2>{{ title('management') }}</h2>
                <blockquote>{{ title('quote') }}</blockquote>
                <div class="contact-list">
                    <contact-card :key="person.id" v-for="person in persons" :contact="person" @show="showContact" />
                </div>
            </div>
        </section>
        <contact-view :contact="activeContact" @close="closeContact" />
    </div>
</template>

<script>

    import VisionMission from './about/VisionMission.vue';
    import AboutIntro from './about/AboutIntro.vue';
    import ErtekRend from './about/ErtekRend.vue';
    import History from './about/History.vue';
    import ContactCard from './ContactCard.vue';
    import ContactView from './ContactView.vue';
    import { throttle, find } from 'lodash-es';
    import axios from 'axios';

    export default {
        components: {
            VisionMission,
            ContactCard,
            ContactView,
            AboutIntro,
            ErtekRend,
            History,
        },
        beforeMount() {
            this.addEvents();
        },
        mounted() {
            this.setActive = throttle(this.setActive, 100);
            axios
                .get(`/pa/management/`)
                .then(resp => {
                    this.persons = resp.data || [];
                    this.showContactbyName(this.$route.params.name);
                });

        },
        computed: {
            currentLanguage() {
                return this.$route.params.lang || 'en';
            },
            percentage() {
                var height = Math.max(
                    document.body.scrollHeight,
                    document.body.offsetHeight,
                    document.documentElement.clientHeight,
                    document.documentElement.scrollHeight,
                    document.documentElement.offsetHeight
                );
                return Math.round(this.scroll / (height - window.innerHeight) * 100);

            }
        },
        methods: {
            showContactbyName(name) {
                if (name) {
                    let colleague = this.persons.filter((person) => person.last_name + '_' + person.first_name == name);
                    if(colleague.length  > 0) this.activeContact = colleague[0];
                }
            },
            addEvents() {
                window.addEventListener('scroll', event => {
                    this.scroll = window.scrollY;
                    this.setActive();
                });
            },
            setActive() {
                for (var i = 0; i < this.sections.length; i++) {
                    if(window.document.getElementById(this.sections[i].name)) {
                        var sizes = window.document.getElementById(this.sections[i].name).getBoundingClientRect();
                        this.sections[i].top = sizes.top;
                        if(sizes.top > window.innerHeight/2) break;
                        this.activeSection = this.sections[i].name;
                    }
                }
            },
            title(chapter) {
                return find(this.sections, { name: chapter} )[this.currentLanguage];
            },
            showContact(contact) {
                document.body.classList.add('hide-overflow');
                this.activeContact = contact;
                this.$router.push({ path: `/${this.currentLanguage}/munkatarsainkrol/${contact.last_name+ '_'+contact.first_name }`});
            },
            closeContact() {
                this.activeContact = {};
                this.$router.push({ path: `/${this.currentLanguage}/munkatarsainkrol`});
            }
        },
        data() {
            return {
                activeContact: {},
                sections: [
                    {
                        top: 0,
                        name: 'the-company',
                        en: 'The company',
                        de: 'Firma',
                        hu: 'A Cég'

                    },
                    {
                        top: 0,
                        name: 'our-vision',
                        en: 'Our Vision',
                        de: 'Vision',
                        hu: 'Jövőképünk'
                    },
                    {
                        top: 0,
                        name: 'value-system',
                        en: 'Value system',
                        de: 'Value system',
                        hu: 'Ertékrend'
                    },
                    {
                        top: 0,
                        name: 'history',
                        en: 'History',
                        de: 'Geschichte',
                        hu: 'Történetünk'
                    },
                    {
                        top: 0,
                        name: 'management',
                        en: 'Management',
                        de: 'Management',
                        hu: 'Vezetőink'
                    },
                    {
                        name: 'quote',
                        en: 'Colleagues for decades.',
                        de: 'Colleagues for decades.',
                        hu: 'Évtizedek óta együtt dolgozunk'
                    }
                ],
                activeSection: '',
                scroll: 0,
                persons: [],
                aboutPage: window.location.pathname.indexOf("rolunk") != -1,
                w: window.innerWidth,
            }
        }
    }

</script>

<style lang="scss">
    body {
        overflow-x: hidden;

        &.show-mobile-menu,
        &.hide-overflow,
        &.show-sectors {
            overflow-x: hidden !important;
            overflow: hidden !important;
        }
    }
</style>
<style lang="scss" scoped>

    @import './../../sass/variables';
    
    h2 {
        @media screen and (max-width: $mobile-max) {
			padding-top: 50px;
		}
    }

    #management {
        padding-bottom: 11vw;
        margin-bottom: 100px;
        position: relative;
        display: block;
        top: 11vw;

        blockquote {
            margin: 0 auto;
        }
    }

    .page-navigation {
        transform: translate(0, -50%);
        position: fixed;
        display: block;
        z-index: 1000;
        right: 10px;
        top: 50%;

        &:hover {

            &:after {
                transform: translate(-30%, -50%) scale(1);
            }

            ul {
                li {
                    a {
                        color: #fff;

                        span {
                            transition: all 300ms;
                            display: block;
                            color: $blue;

                            @media screen and (max-width: $tablet-max) {
                                display: none;
                            }
                        }
                    }
                }
            }
        }

        &:after {
            transform: translate(-10%, -50%) scale(0);
            background-color: $light-blue;
            transform-origin: 80% 50%;
            transition: all 300ms;
            border-radius: 50%;
            position: absolute;
            display: block;
            height: 600px;
            opacity: 0.8;
            width: 600px;
            content: '';
            z-index: 1;
            top: 50%;
            left: 0;

            @media screen and (max-width: $tablet-max) {
                display: none;
            }
        }

        ul {
            position: relative;
            z-index: 999;

            li {
                text-align: right;

                a {
                    position: relative;
                    font-size: 20px;
                    display: block;
                    color: $black;
                    height: 40px;
                    width: 40px;

                    span {
                        transform: translate(0%, -60%);
                        transition: all 300ms;
                        border-radius: 15px;
                        position: absolute;
                        padding: 0 5px;
                        display: none;
                        width: 300px;
                        right: 100%;
                        top: 50%;

                        @media screen and (max-width: $tablet-max) {
                            display: none;
                        }
                    }

                    &.active {

                        &:before {
                            border: 2px solid #fff;
                            background-color: $blue;
                        }
                    }

                    &:hover {

                        span {
                            color: lighten($blue, 25%);
                            transition: all 300ms;
                            display: block;

                            @media screen and (max-width: $tablet-max) {
                                display: none;
                            }
                        }

                        &:before {
                            border: 2px solid transparent;
                            background-color: $blue;
                        }
                    }

                    &:before {
                        transform: translate(50%, -50%);
                        border: 2px solid $blue;
                        background-color: #fff;
                        border-radius: 50%;
                        position: absolute;
                        height: 15px;
                        content: '';
                        width: 15px;
                        right: 50%;
                        top: 50%;
                    }

                    &:after {
                        display: none;
                    }
                }
            }
        }
    }

    .progress-bar {
        position: fixed;
        z-index: 1000;
        height: 3px;
        width: 100%;
        bottom: 0;
        left: 0;
        top: 0;

        .bar {
            box-shadow: 0 1px 0 rgba(255,255,255,0.5);
            background-color: $blue;
            transition: all 50ms;
            position: absolute;
            display: block;
            height: 100%;
            width: 0;
            left: 0;
            top: 0;
        }
    }

    .contact-list {
        flex-wrap: wrap;
        margin: 0 -20px;
        display: flex;
    }

</style>
